import type { ElementType } from 'react';

import CreditCardForm, { NotFoundCreditCard } from './CreditCardForm';
import PaymentWrapper from './PaymentWrapper';

type MapperPaymentView = Record<string, ElementType>;

export const mapperPaymentViews: MapperPaymentView = {
  'payment.creditCardForm': CreditCardForm,
  'payment.errors': NotFoundCreditCard,
  'payment.selector': PaymentWrapper,
};
